/**
 * 格式化时间为北京时间字符串
 * @param {string|number|Date} time - 时间
 * @returns {string}
 * @example _formatTime('2026-01-01T00:00:00Z') // '2026-01-01 08:00:00'
 */
export const _formatTime = (time) => {
  if (!time) return ''
  const date = new Date(time)
  const beijingTime = new Date(date.getTime() + 8 * 3600 * 1000)
  const year = beijingTime.getUTCFullYear()
  const month = String(beijingTime.getUTCMonth() + 1).padStart(2, '0')
  const day = String(beijingTime.getUTCDate()).padStart(2, '0')
  const hours = String(beijingTime.getUTCHours()).padStart(2, '0')
  const minutes = String(beijingTime.getUTCMinutes()).padStart(2, '0')
  const seconds = String(beijingTime.getUTCSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}


/**
 * determine whether it is wechat and not a wxwork platform
 * @returns bool
 */
export const isWeChat = () => {
  const ua = navigator.userAgent
  return /micromessenger/i.test(ua) && !/wxwork/i.test(ua) && !/miniprogram/i.test(ua)
}